module.exports = __webpack_public_path__ + "img/banner.025b9920.gif";